import { Form } from 'antd'
import { useEffect } from 'react'

export const ControlledForm = (props) => {
  const {
    value,
    children,
    onChange = () => {},
    onSubmit = () => {},
    style = {},
    errors = [],
  } = props || {}
  const [form] = Form.useForm()
  useEffect(() => {
    form.setFieldsValue(value)
  }, [value])
  useEffect(() => {
    form.setFields(errors)
  }, [errors])

  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={(values) => {
        onSubmit(values);
      }}
      onValuesChange={(v, values) => {
        onChange(values, v)
      }}
      style={style}
    >
      {children}
    </Form>
  )
}
